var map = {
	"./adult/nn/4 1 Skrivehastighet Intro.mp3": 790,
	"./adult/no/4 1 Skrivehastighet Intro.mp3": 791,
	"./adult/se/4 1 Skrivehastighet Intro.mp3": 792,
	"./youth/de/4 1 Skrivehastighet Intro.mp3": 793,
	"./youth/nn/4 1 Skrivehastighet Intro.mp3": 794,
	"./youth/no/4 1 Skrivehastighet Intro.mp3": 795,
	"./youth/se/4 1 Skrivehastighet Intro.mp3": 796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 789;